<template>
    <div class="section_title">
        <p class="section_title_text">Latest News</p>
    </div>
    <div class="content_inner">
        <div class="card_wrapper img_right with_sup" v-for="(card, index) in list" :key="index">
            <p class="publish_time sup">{{ convertDateToFormat(card.article_date_publish) }}</p>
            <a :href="'/article/' + card.nid" class="card_img_wrapper">
                <img class="card_img" :src="card.article_image" :alt="card.article_image_description">
            </a>
            <div class="card_content_wrapper">
                <a :href="'/article/' + card.nid" class="card_title">{{ card.article_title }}</a>
                <p class="card_desc">{{ card.article_brief }}</p>
                <div class="card_info_wrapper">
                    <div class="card_info_content authors">
                        <span class="author_text">By</span>
                        <a :href="'/author/' + card.article_authors_id[0]" class="author_link">{{ card.article_authors[0] }}</a>
                    </div>
                    <span class="card_info_content publish_time">{{ convertDateToFormat(card.article_date_publish) }}</span>
                </div>
            </div>
        </div>
    </div>
    <img src="/images/ajax-loader.gif" class="loading_indicator" alt="" v-show="loading">
</template>

<script>
    import { convertDateToFormat } from '@vuePath/tools/tool';
    import { loadMore } from '@vuePath/api/article';
    export default {
        props: {
            typeId: {
                type: String
            },
            csrfToken: {
                type: String
            }
        },
        data() {
            return {
                list: [],
                page: 1,
                size: 6,
                loading: false,
                refresh: false,
                load_data: false
            }
        },
        created() {
            window.addEventListener('scroll', this.handleScroll);
        },
        async mounted() {
            await this.getData();
        },
        methods: {
            getData() {
                this.loading = true;
                return new Promise((resolve, reject) => {
                    loadMore('author', this.typeId, this.page, this.size).then((response) => {
                        let data = response.data.data;
                        this.refresh = data.refresh;

                        if (this.page === 1) {
                            this.list = data.data;
                        } else {
                            if (this.refresh === 'false') {
                                this.list = this.list.concat(data.data);
                            } else {
                                this.list = data.data;
                            }
                        }

                        if (data.data.length > 0) {

                            if (data.data.length < this.size) {
                                this.load_data = false;
                            } else {
                                this.load_data = true;
                            }
                        } else {
                            if (this.page > 1) {
                                this.page -= 1;
                            }
                        }
                        this.loading = false;
                        resolve(response);
                    }).catch((err) => {
                        reject(err);
                    });
                });
            },
            convertDateToFormat(timestamp) {
                return convertDateToFormat(timestamp);
            },
            async updateData() {
                this.page += 1;
                this.load_data = false;
                await this.getData();
            },
            handleScroll() {
                if (this.load_data) {
                    this.last_scroll = window.pageYOffset;
                    let that = this;
                    window.requestAnimationFrame(function () {
                        let window_bottom = that.last_scroll + window.innerHeight;
                        let category_bottom = document.getElementById('author_card_wrapper').offsetTop
                            + document.getElementById('author_card_wrapper').clientHeight;
                        if (window_bottom > category_bottom) {
                            that.updateData();
                        }
                    });
                }
            },
        }
    }
</script>
